<template>
  <aside class="hidden lg:block space-y-6">
    <div>
      <h3 class="font-semibold text-lg mb-4 text-grey-light-900">Type</h3>
      <div class="space-y-3">
        <label v-for="(type, i) in filterTypes" :key="i" class="flex items-center gap-2 cursor-pointer">
          <Checkbox :id="`dt-${i}`" v-model="type.selected" />
          <span class="text-grey-light-700">{{ type.name }}</span>
        </label>
      </div>
    </div>

    <hr class="border-grey-light-200" />

    <div v-if="shopsStore.currentProduct === 'layby' || shopsStore.currentProduct === 'plans'">
      <h3 class="font-semibold text-lg mb-4 text-grey-light-900">
        {{ shopsStore.currentProduct === 'layby' ? 'Lay-by Duration' : 'Plan Duration' }}
      </h3>
      <div class="space-y-3">
        <label v-for="(dur, i) in filterDurations" :key="i" class="flex items-center gap-2 cursor-pointer">
          <Checkbox :id="`dd-${i}`" v-model="dur.selected" />
          <span class="text-grey-light-700">{{ dur.name }}</span>
        </label>
      </div>
    </div>

    <div v-if="shopsStore.currentProduct === 'boost'">
      <h3 class="font-semibold text-lg mb-4 text-grey-light-900">Reward Percentage</h3>
      <div class="space-y-3">
        <label v-for="(perc, i) in filterRewardPercentages" :key="i" class="flex items-center gap-2 cursor-pointer">
          <Checkbox :id="`dp-${i}`" v-model="perc.selected" />
          <span class="text-grey-light-700">{{ perc.name }}</span>
        </label>
      </div>
    </div>

    <hr v-if="shopsStore.currentProduct === 'boost'" class="border-grey-light-200" />

    <div v-if="shopsStore.currentProduct === 'boost'">
      <h3 class="font-semibold text-lg mb-4 text-grey-light-900">Minimum Savings Amount</h3>
      <div class="space-y-3">
        <label v-for="(amt, i) in filterMinimumAmounts" :key="i" class="flex items-center gap-2 cursor-pointer">
          <Checkbox :id="`da-${i}`" v-model="amt.selected" />
          <span class="text-grey-light-700">{{ amt.name }}</span>
        </label>
      </div>
    </div>

    <div class="pt-4">
      <Button type="button" variant="outline" class="w-full" @click="shopsStore.clearFilters">
        Clear All Filters
      </Button>
    </div>
  </aside>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { useShopsStore } from '@/stores/shops';
import { storeToRefs } from 'pinia';

const shopsStore = useShopsStore();
const { filterTypes, filterDurations, filterRewardPercentages, filterMinimumAmounts } = storeToRefs(shopsStore);
</script>
